import { render, staticRenderFns } from "./UntBuyLine.vue?vue&type=template&id=33edbf1a&scoped=true"
import script from "./UntBuyLine.vue?vue&type=script&lang=js"
export * from "./UntBuyLine.vue?vue&type=script&lang=js"
import style0 from "./UntBuyLine.vue?vue&type=style&index=0&id=33edbf1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edbf1a",
  null
  
)

export default component.exports